<template>
  <el-container id="content_box">
    <el-header id="myhead">
      <HeaderBar :toggle-side-bar="toggleSideBar" :is-active="isCollapse"></HeaderBar>
    </el-header>
    <el-container class="aside_box">
      <el-scrollbar wrap-class="scrollbar-wrapper-y">
        <el-aside width="auto">
          <el-menu
            default-active="1-4-1"
            class="el-menu-vertical-demo"
            @select="openTab"
            :collapse="isCollapse"
            :collapse-transition="false"
            background-color="#2e4050"
            text-color="#fff"
            :unique-opened="true"
			:default-openeds="opends"
          >
              <template v-for='(menu1,index1) in menus' >
                  <el-submenu :key="index1" v-if="menu1.children" :index="menu1.index">
                      <template slot="title">
                          <i :class="menu1.icon"></i>
                          <span slot="title">{{menu1.title}}</span>
                      </template>
                      <template v-for='(menu2,index2) in menu1.children' >
                          <el-submenu :key="index2" v-if="menu2.children" :index="menu2.index">
                              <template slot="title">
                                  <i :class="menu2.icon" v-if="menu2.icon"></i>
                                  <span slot="title">{{menu2.title}}</span>
                              </template>
                              <el-menu-item v-for="(menu3,index3) in menu2.children" :key="index3" :index="menu3.index">{{menu3.title}}</el-menu-item>
                          </el-submenu>
                          <el-menu-item :key="index2" v-else :index="menu2.index">
                              <i :class="menu2.icon" v-if="menu2.icon"></i>
                              <span slot="title">{{menu2.title}}</span>
                          </el-menu-item>
                      </template>
                  </el-submenu>
                  <el-menu-item :key="index1" v-else :index="menu1.index">
                      <i :class="menu1.icon"></i>
                      <span slot="title">{{menu1.title}}</span>
                  </el-menu-item>
              </template>
            <!--<el-submenu index="1">-->
              <!--<template slot="title">-->
                <!--<i class="el-icon-menu"></i>-->
                <!--<span slot="title">权限管理</span>-->
              <!--</template>-->
              <!--<el-menu-item index="1-1">系统配置</el-menu-item>-->
              <!--<el-menu-item index="1-2">模块配置</el-menu-item>-->
              <!--<el-menu-item index="1-3">权限配置</el-menu-item>-->
            <!--</el-submenu>-->
            <!--<el-menu-item index="2">-->
              <!--<i class="el-icon-document"></i>-->
              <!--<span slot="title">角色管理</span>-->
            <!--</el-menu-item>-->
            <!--<el-menu-item index="3">-->
              <!--<i class="el-icon-location"></i>-->
              <!--<span slot="title">人员管理</span>-->
            <!--</el-menu-item>-->
          </el-menu>
        </el-aside>
      </el-scrollbar>
      <el-main class="home_main">
        <tab-view/>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
// @ is an alias to /src
import { mapActions } from "vuex";
import TabView from "../components/TabView.vue";
// import menus from './menuconfig'
import store from '../store'
import Cookies from 'js-cookie';
import HeaderBar from "../components/HeaderBar/index";
import config from "../config/config";
import api from "../config/apiConfig";
import axios from "axios";
import myUtil from "../utils/util";
export default {
	name: "home",
	data: function() {
		return {
			isCollapse: false,
			mainboxH: 0,
			menus:[],
			opends:['0','1','2'],
		};
	},
	components: {
		TabView,
		HeaderBar
	},
	// created(){
	// 	setTimeout( () => {
	// 		// this.menus.push(...store.state.menus)
	// 		this.$store.commit('updateMenulist')
	// 		// console.log(this.$store.state,"=====1==")
	// 		// this.menu = JSON.stringify(this.$store.state.menus)
	// 		console.log(store.state,"=====1==")
	// 		// this.$store.state.menus = JSON.parse(JSON.stringify(this.$store.state.menus))
	// 		this.menus.push(...store.state.menus)
	// 	},100)
	// },
	mounted(){
		// updateMenulist(state) {
			var _this = this;
			var roleId = _this.$cookie.get(_this.$config.cookies.currRoleId);
			if (roleId === undefined || roleId === '') {
				return;
			}
			var url = _this.$api.menu.role + roleId;
			var index = -1;
			_this.$httpUtil.ajaxGet(_this,url,null,function (response) {
				var dbList = response.data.data;
				// console.log(dbList,"===data=====1===");
				var sortList = dbList.sort(myUtil.compare('sort'));
				// console.log(sortList,"===data=====2===");
				// var menuStr = "";
				var menusObj = {};
				var res = [];
				sortList.forEach((item) => {
					if (item.parentId === '0' || item.parentId === 0) {
						var p = {
							// path: '/' + item.menuNameZh,
							icon: item.menuClass,
							title: item.menuNameZh,
							routername: item.menuNameEn,
							children: []
						};
						index++;
						res.push(p);
						// menusObj.push(p);
					} else {
						var c = {
							// path: item.menuNameZh,
							icon: item.menuClass,
							title: item.menuNameZh,
							routername: item.menuNameEn,
						};
						res[index].children.push(c);
						// menusObj[index].children.push(c);
					}
					// menuStr = menuStr + item.menuNameEn + ",";
				});
				res.forEach((menu1, index1) => {
					menu1.index = index1.toString();
					if (menu1.children) {
						menu1.children.forEach((menu2, index2) => {
							menu2.index = index1 + '.' + index2;
							if (menu2.children) {
								menu2.children.forEach((menu3, index3) => {
									menu3.index = index1 + '.' + index2 + '.' + index3;
								})
							}
						})
					}
				})
				console.log('ress', res);
				_this.menus = res;
			});

	},
	methods: {
		...mapActions("tab", ["reflush"]),
		handleOpen(key, keyPath) {
			console.log(key, keyPath);
		},
		toggleSideBar() {
			this.isCollapse = !this.isCollapse;
		},
		openTab(key, keyPath) {
			var items= this.menus;
			var item = null;
			var ids = key.split('.').map(i=>parseInt(i));
			ids.forEach(i=>{
				if(items[i].children) items = items[i].children;
				else item = items[i];
			})
			if(item.routername){
				if(this.$router.currentRoute.name==item.routername){
					this.reflush();
				}
				else {
					this.$store.commit("tab/DelCache", item.routername);
					this.$router.push({name:item.routername});
				}
			}
			else console.warn('该菜单未配置路由')
		}
	}
};
</script>
<style  scoped>
	/*@import "../../src/style/color.less";*/
#content_box {
  height: 100%;
}
.el-header {
  background-color: #409eff;
  color: #333;
  line-height: 50px;
  height: 50px !important;
  padding: 0;
}
.aside_box {
  height: 100%;
  /*background-color: white;*/
	background-color: #2e4050;
  color: #333;
}

.el-menu-vertical-demo:not(.el-menu--collapse) {
  min-width: 180px;/* 左边导航宽度 */
  /*min-height: 100%;*/
	min-height: 500px;
}
.el-main {
  /*background-color: #fff;*/
	/*background-color:  #409eff;*/
	/*background: linear-gradient(to right, #CCFFFF, #CCFFFF);*/
	background-color:  white;
  color: #333;
  height: 100%;
  padding: 0;
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/views/Home.vue